import { Box } from '@mui/material';
import React from 'react';
import QRCode from 'react-qr-code';

import { AppStoreBadgeLink, PlayStoreBadgeLink } from '@/components';
import { APP_CONFIG } from '@/constants/appConfig';
import { useRegion } from '@/hooks/useRegion';
import { COLOR } from '@/theme/colors';

const STORES_SECTION_WIDTH = 135;
const QR_CODE_SIZE = 113;

const AppPromotion: React.FC = () => {
    const userRegion = useRegion();

    const regionParams = userRegion?.code
        ? `?region=${userRegion.code.toLocaleLowerCase()}`
        : '';
    const equinetAppLink = `${APP_CONFIG.firebaseHostDomain}/get-mobile-app${regionParams}`;

    return (
        <Box
            className={`flex flex-col justify-between w-[${STORES_SECTION_WIDTH}px]`}
        >
            <QRCode
                size={QR_CODE_SIZE}
                style={{
                    height: 'auto',
                    maxWidth: '100%',
                    width: '100%',
                    minWidth: 132,
                    padding: 10,
                    border: `1px ${COLOR.alto} solid`,
                    borderRadius: 10,
                }}
                value={equinetAppLink}
                viewBox={`0 0 ${STORES_SECTION_WIDTH} ${STORES_SECTION_WIDTH}`}
            />
            <Box className="border-b-[1px] border-alto my-[12px]" />
            <Box className="flex flex-col gap-[8px]">
                <AppStoreBadgeLink />
                <PlayStoreBadgeLink />
            </Box>
        </Box>
    );
};

export default AppPromotion;
